import React from 'react';
import { ReactComponent as AiSuggestionsIcon } from '../../../../../elements/icon/assets/ai_icon_suggestions.svg';
import {
  PopupContainer,
  SuggestionList,
  SuggestionItem,
  IconWrapper
} from './AISuggestionsPopup.styled';

const getContextualSuggestions = (type) => {
  switch (type) {
    case 'garage':
      return [
        'Notify them about the repair progress and provide an estimated completion timeframe.',
        'Update the client about the status to ensure clarity.',
        'Follow up to ensure satisfaction and discuss any recommendations for future maintenance.'
      ];
    case 'appointments':
      return [
        'Send a reminder to schedule their next maintenance appointment.',
        'Confirm the details and proceed with booking a time for a seamless experience.',
        'Schedule a recall appointment and inform the client on how to proceed.',
        'Offer to assist in booking a recall appointment for prompt service.',
        'Initiate a test drive booking conversation to engage further.'
      ];
    case 'alerts':
      return [
        'Send a reminder and mention any relevant upgrade options they could explore during their visit.',
        'Notify them about the repair progress and provide an estimated completion timeframe.',
        'Schedule a recall appointment and inform the client on how to proceed.',
        'Offer to assist in booking a recall appointment for prompt service.'
      ];
    case 'contractsAlert':
      return [
        'How much equity does this car have?',
        'What is the replacement vehicle for this client?',
        'What is the delta (difference in payment)?',
        'What is the difference in payment going from a lease to a purchase?',
        'Write a script to discuss contract maturity with the client.',
        'Draft an email to notify the client about their contract nearing maturity and offer options.',
        'How many months are left in the current contract?',
        'What is their current payment?',
        'What is a lease option versus buying?',
        'What are the customer\'s options for buying out their current lease contract?',
      ]
    case 'warrantyAlert':
      return [
        'How many miles are left on the warranty?',
        'Is there a replacement vehicle available for this client?',
        'How much time is left on the warranty?',
        'Write a recommendation based on warranty status for this client.',
        'Create a script, email, and SMS to alert the client about their warranty status and upgrade options.',
        'Can they upgrade their vehicle?',
        'How many service visits have they made since owning the vehicle?',
        'How much RO work has the Warranty covered since owning the vehicle?',
        'Can they purchase additional warranty coverage if they are not ready to upgrade?',
        'If the same OEM model, but they have not been serviced here, write an email to check in and get an update on mileage.',
    ]
    case 'upgradeAlert':
      return [
        'Help write a script to present the upgrade opportunity.',
        'Draft an email to offer a replacement vehicle to the client.',
        'Write an SMS to connect with the client about the upgrade opportunity.',
        'What are the payment details on the replacement vehicle?',
        'Compare the replacement vehicle with the client’s current one and check inventory availability.',
        'Provide an estimated loan amount for the replacement vehicle.',
        'Do we have their upgrade vehicle in stock? If so, how many? What is the customer’s current payment?',
        'What is the delta between the current payment and the new payment?',
        'Write an email to see if the customer is interested in the same type of vehicle they currently own or if their preference changed.',
      ]
    case 'serviceAlert':
      return [
        'How many miles are left until the next service is due?',
        'Is there a recall for this vehicle?',
        'Write a script to follow up with customers who recently visited the service lane.',
        'Draft an SMS and email to discuss service follow-ups and potential upgrades.',
        'What work did they get done on their previous visit?',
        'Are there any current recall alerts for this customer who has a service alert due?',
        'Does this customer have prepaid maintenance?',
        'Write a script to follow up with customers who recently visited Quick Lane.',
        'Write an email to a customer who recently missed their scheduled service appointment to reschedule.',
        'Write an email to a customer who has never serviced here with the same OEM make.',
      ]
    case 'inMarketAlert':
      return [
        'Compare the client’s current vehicle with the replacement.',
        'What is the difference in payment between the current and replacement vehicles?',
        'What is the likelihood that this client will buy?',
        'Do I have the replacement vehicle in inventory?',
        'Draft a script and email for clients flagged as likely buyers.',
        'Write an email to check with customers browsing vehicle listing pages and or vehicle detailed pages.',
        'Write an email to invite customers to the dealership who have been on the website using trade-in tools, quote requests, payment calculators, getting prequalified, and asking for more information',
        'Write an email to follow up with a customer who has saved vehicles online.',
        'Write an email to follow up with a customer who has repeat visits to the dealership website within a short timeframe.',
        'Write an email to follow up with a customer who interacted with campaigns or offers on the website.',
        'Write an email to customers with high engagement per session on our website.',
      ]
    case 'pendingServicesAlert':
      return [
        'Is there a replacement car for this client?',
        'How much warranty is left on their current vehicle?',
        'Are there any incentives available for this client?',
        'Write a script, email, and SMS to connect the pending service appointment with upgrade opportunities.',
        'Write an email to check with the customer to see if they still own the vehicle listed.',
        'Write an email that identifies the importance of the current OEM recommended service that is due.',
        'Write an email highlighting the risks of delaying the recommended service.',
        'Are there any complimentary service inspections we can offer?',
        'Create an SMS to remind the customer of their pending service and promote same-day availability.',
        'Write a follow-up email to reschedule services canceled or missed.',
        'What incentives can be offered for completing their service, such as loyalty points?',
      ]
    case 'mileageAlert':
      return [
        'How many miles are left on the lease?',
        'Is there a replacement vehicle available for this client?',
        'Write a script to explain mileage thresholds and upgrade options.',
        'Draft an email and SMS to discuss lease options and next steps.',
        'What is the estimated Mileage Fee if they continue driving at this rate?',
        'Write an email to check in with the customer based on their position in their lease to see if they are thinking of moving to a different model than they currently own.',
        'What is the recommended strategy for customers significantly over their mileage limit?',
        'Draft an email explaining the financial benefits of upgrading before lease maturity.',
        'Create a phone script to introduce early upgrade opportunities tied to mileage overages.',
        'Write an SMS offering a consultation to discuss mileage concerns and next steps.',
        'Identify similar vehicles in stock with lower lease rates and mileage flexibility.',
      ]
    case 'flexAlert':
      return [
        'Help write a script to explain flexible terms and payment options.',
        'Draft an email offering flexible upgrade terms.',
        'Write an SMS to connect with the client about flexible payment opportunities.',
        'What are the payment details for the replacement vehicle?',
        'Compare the replacement vehicle with the current one and check inventory availability.',
        'Provide an estimated loan amount for the replacement vehicle.',
        'What are the customer\'s priorities: lower payments, shorter terms, or additional features?',
        'Write a phone script emphasizing the benefits of switching to flexible terms.',
        'Draft an email showcasing the flexibility of lease terms for a new model.',
        'Offer a personalized consultation to explain their options based on the current vehicle.',
        'Create an SMS offering to discuss tailored financing options for their next vehicle.',
      ]
    default:
      return [
        'Give me a summary of this customer Alerts',
        'What is the replacement vehicle for this customers',
        'Suggest Emails that I can send to this Customer',
        'Draft an email for this Customer',
        'Draft an SMS for this customer'
      ];
  }
};

const AISuggestionsPopup = ({ type, onSelect, onClose }) => {
  const suggestions = getContextualSuggestions(type);

  const handleSelect = (suggestion) => {
    onSelect(suggestion);
    onClose();
  };

  return (
    <PopupContainer>
      <SuggestionList>
        {suggestions.map((suggestion, index) => (
          <SuggestionItem
            key={index}
            onClick={() => handleSelect(suggestion)}
          >
            <IconWrapper>
              <AiSuggestionsIcon width="20px" height="23px" />
            </IconWrapper>
            {suggestion}
          </SuggestionItem>
        ))}
      </SuggestionList>
    </PopupContainer>
  );
};

export default AISuggestionsPopup; 